export enum ActorType {
  HARBOUR = 'HARBOR',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
}

export enum CommercialMode {
  SUBSCRIPTION_ONLY = 'SUBSCRIPTION_ONLY',
  COMMISSION_ONLY = 'COMMISSION_ONLY',
  HYBRID = 'HYBRID',
}

export interface CommissionPolicy {
  id: string;
  actor_type: ActorType;
  actor_id: string | null;
  commercial_mode: CommercialMode;
  commission_rate: number;
  effective_from: string;
  active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CommissionPolicyCreatePayload {
  actor_type: ActorType;
  actor_id: string | null;
  commercial_mode: CommercialMode;
  commission_rate: number;
  effective_from: string;
  active: boolean;
}

export interface CommissionPolicyUpdatePayload {
  commercial_mode?: CommercialMode;
  commission_rate?: number;
  effective_from?: string;
  active?: boolean;
}
